export default "__VITE_ASSET__B0KTGjxV__"